
/* injects from baggage-loader */

'use strict';

export default class GameplayInputRadioController {
    constructor($log, $scope, $rootScope) {
        'ngInject';
        this.$log = $log;
        this.$scope = $scope;        
        this.$rootScope = $rootScope;        
    }
    isActive() {
        return this.value === this.ngModel
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/gameplay-input-radio/gameplay-input-radio.controller.js